module.exports = __webpack_public_path__ + "static/media/roberto-cavalli-women-big.70b5f3ba.png";